// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3SdrY","legacyBtn":"MutateMid_legacyBtn__juNLP"};